<template>
<CityBackgroundImage :add-header="true">
  <div class="md-layout md-alignment-top-center list-project-page">
    <md-card class="md-layout-item md-size-80 md-small-size-100">
      <md-card-content>
        <md-table v-model="projects" md-sort="id" md-sort-order="desc" md-card md-fixed-header @md-selected="onSelect">
          <md-table-toolbar>
            <div class="md-toolbar-section-start">
              <h1 class="asu-title">Proyectos</h1>
            </div>

            <md-field md-clearable class="md-toolbar-section-end">
              <md-input placeholder="Buscar por nombre..." v-model="search" @input="searchOnTable" />
              <i class="material-icons">search</i>
            </md-field>
          </md-table-toolbar>

          <md-table-empty-state
            md-label="Proyectos no encotrados"
            :md-description="`Los proyectos con el nombre '${search}' no fueron encontrados.`">
          </md-table-empty-state>

          <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
            <md-table-cell md-label="ID" md-sort-by="id" md-numeric>{{ item.id }}</md-table-cell>
            <md-table-cell md-label="Código" md-sort-by="code">{{ item.code }}</md-table-cell>
            <md-table-cell md-label="Nombre" md-sort-by="name">{{ item.name }}</md-table-cell>
            <md-table-cell md-label="Costo" md-sort-by="costo">{{ item.costo }}</md-table-cell>
            <md-table-cell md-label="Tipos" >{{ formatTypes(item.types) }}</md-table-cell>
            <md-table-cell md-label="Estado" >{{ getCurrentStatus(item.status) }}</md-table-cell>
            <md-table-cell md-label="Acción" >
              <ButtonWithAlertDialog
                class="material-icons-button md-dense md-raised md-accent"
                title="Eliminar proyecto"
                message="¿ Está seguro que desea eliminar este proyecto ?"
                @on-confirm="deleteProject(item.code)"
              >
                <i class="material-icons icon-size-16">delete</i>
                <md-tooltip md-direction="left">Eliminar</md-tooltip>
              </ButtonWithAlertDialog>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>
      <md-card-actions>
        <md-button class="material-icons-button md-raised md-primary" :href="`/project/create`">
          <i class="material-icons">add</i>
        </md-button>
      </md-card-actions>
    </md-card>
  </div>
</CityBackgroundImage>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ProjectService from '@/services/projects.js'

const initialTableHeight = '65vh'

const toLower = text => text.toString().toLowerCase()

const searchByName = (items, term) => {
  if (term) return items.filter(item => toLower(item.name).includes(toLower(term)))
  return items
}

export default {
  name: 'ListProject',
  data () {
    return {
      search: '',
      projects: [],
      allProjects: []
    }
  },
  methods: {
    ...mapActions([ 'redirectToLogin' ]),
    searchOnTable () {
      this.projects = searchByName(this.allProjects, this.search)
    },
    formatTypes (types) {
      if (!types) return []
      return types.join(', ')
    },
    getCurrentStatus (status) {
      if (!status) return null
      return ProjectService.getCurrentState(status)
    },
    onSelect (item) {
      this.$router.push({ name: 'editProject', params: { code: item.code } })
    },
    loadProjects () {
      ProjectService.getProjects(this.$http, this.apiKey).then(projects => {
        this.allProjects = projects
        this.projects = projects
      })
    },
    setHeightInTableContent (height) {
      setTimeout(() => {
        const tableContent = document.querySelector('.md-table-content')
        tableContent.style.height = height
        tableContent.style.maxHeight = height
      })
    },
    deleteProject (projectCode) {
      ProjectService.deleteProject(this.$http, this.apiKey, projectCode).then(() => window.location.reload())
    }
  },
  mounted () {
    if (!(this.apiKey)) return this.redirectToLogin()
    this.loadProjects()
    window.matchMedia('(max-height: 750px)').addListener(vh => {
      if (vh.matches) {
        this.setHeightInTableContent('50vh')
      } else {
        this.setHeightInTableContent(initialTableHeight)
      }
    })
  },
  computed: {
    ...mapGetters([ 'apiKey' ])
  },
  watch: {
    projects () {
      this.setHeightInTableContent(initialTableHeight)
    },
    apiKey (val) {
      if (val) this.loadProjects()
    }
  }
}
</script>
<style scoped lang="stylus">
@import '~@/styles/variables'
.md-toolbar.md-table-toolbar
  padding: 0

.material-icons-button.md-dense
  width: $f24px
  min-width: $f24px
  height: $f24px

</style>
